import articleAhamoV2 from "@/assets/editorial/article-illustrations/ahamo-guide/cover.webp";
import articleBeforeSwitchingV2 from "@/assets/editorial/android-switch/article-before-switching-cover.webp";
import articleBillBasicsV2 from "@/assets/editorial/article-illustrations/bill-basics/cover.webp";
import articleDataUsageV2 from "@/assets/editorial/article-illustrations/data-usage/cover.webp";
import articleIijmioV2 from "@/assets/editorial/article-illustrations/iijmio-guide/cover.webp";
import articleIphoneBuyV2 from "@/assets/editorial/article-illustrations/iphone-buy/cover.webp";
import articleRakutenV2 from "@/assets/editorial/article-illustrations/rakuten-guide/cover.webp";
import articleRepairV2 from "@/assets/editorial/article-illustrations/iphone-repair-or-replace/cover.webp";
import articleUsedIphoneV2 from "@/assets/editorial/article-illustrations/used-iphone-checklist/cover.webp";
import articleReturnProgram from "@/assets/editorial/article-illustrations/iphone-buy/detail-1.webp";
import { legacyArticles } from "@/data/legacyArticles.generated";

export const carriers = [
  {
    id: "docomo",
    name: "ドコモ",
    type: "大手キャリア",
    monthly: "7,315円",
    data: "無制限",
    call: "5分定額 880円",
    store: "全国約2,300店舗",
    contract: "MNP / 新規 / 機種変更",
    strengths: ["店舗サポートが手厚い", "通信品質が安定", "dポイントが貯まる"],
    weaknesses: ["月額料金は割高", "オンライン限定プランは別ブランド"],
  },
  {
    id: "au",
    name: "au",
    type: "大手キャリア",
    monthly: "7,238円",
    data: "無制限",
    call: "5分定額 880円",
    store: "全国約2,000店舗",
    contract: "MNP / 新規 / 機種変更",
    strengths: ["Pontaポイント連携", "光回線とのセット割"],
    weaknesses: ["料金体系が分かりにくい", "オプション見直し推奨"],
  },
  {
    id: "softbank",
    name: "ソフトバンク",
    type: "大手キャリア",
    monthly: "7,238円",
    data: "無制限",
    call: "5分定額 880円",
    store: "全国約2,200店舗",
    contract: "MNP / 新規 / 機種変更",
    strengths: ["PayPay連携がお得", "家族割の適用範囲が広い"],
    weaknesses: ["単身利用ではコスト高"],
  },
  {
    id: "ahamo",
    name: "ahamo",
    type: "オンライン専用",
    monthly: "2,970円",
    data: "30GB",
    call: "5分定額込み",
    store: "オンライン中心",
    contract: "MNP / 新規 / 機種変更",
    strengths: ["5分通話込みで分かりやすい", "海外ローミング対応"],
    weaknesses: ["店舗サポートは有料"],
  },
  {
    id: "povo",
    name: "povo2.0",
    type: "オンライン専用",
    monthly: "基本0円+トッピング",
    data: "選択制",
    call: "従量課金",
    store: "オンライン",
    contract: "MNP / 新規",
    strengths: ["使わない月は基本料金0円", "必要な分だけ購入"],
    weaknesses: ["自分で管理が必要"],
  },
  {
    id: "linemo",
    name: "LINEMO",
    type: "オンライン専用",
    monthly: "990円〜",
    data: "3GB / 20GB",
    call: "オプション",
    store: "オンライン",
    contract: "MNP / 新規",
    strengths: ["LINEギガフリー", "小容量が安い"],
    weaknesses: ["店舗サポート無し"],
  },
  {
    id: "rakuten",
    name: "楽天モバイル",
    type: "第4のキャリア",
    monthly: "1,078円〜3,278円",
    data: "無制限",
    call: "Rakuten Link無料",
    store: "全国約1,000店舗",
    contract: "MNP / 新規 / 機種変更",
    strengths: ["データ無制限で割安", "楽天ポイント連携"],
    weaknesses: ["エリアによって電波にムラ"],
  },
  {
    id: "uqmobile",
    name: "UQモバイル",
    type: "サブブランド",
    monthly: "3,828円〜",
    data: "30GB / 35GB",
    call: "35GBは10分定額込み",
    store: "UQ取扱店舗で対応",
    contract: "MNP / 新規 / 機種変更",
    strengths: ["au回線で高品質", "店舗・端末販売がある"],
    weaknesses: ["割引条件の確認が必要"],
  },
  {
    id: "ymobile",
    name: "ワイモバイル",
    type: "サブブランド",
    monthly: "3,278円〜",
    data: "5GB / 30GB / 35GB",
    call: "35GBは10分定額込み",
    store: "全国約2,600店舗",
    contract: "MNP / 新規 / 機種変更",
    strengths: ["店舗で相談可能", "家族割・端末販売が充実"],
    weaknesses: ["割引条件の確認が必要"],
  },
  {
    id: "iijmio",
    name: "IIJmio",
    type: "格安SIM (MVNO)",
    monthly: "850円〜",
    data: "2GB〜55GB",
    call: "オプション",
    store: "オンライン中心",
    contract: "MNP / 新規",
    strengths: ["端末セット販売が豊富", "料金が最安クラス"],
    weaknesses: ["昼休みの通信速度が落ちる"],
  },
];

const legacyArticleImages: Record<string, string> = {
  "ahamo-guide": articleAhamoV2,
  "before-switching": articleBeforeSwitchingV2,
  "bill-basics": articleBillBasicsV2,
  "data-usage": articleDataUsageV2,
  "iijmio-guide": articleIijmioV2,
  "iphone-buy": articleIphoneBuyV2,
  "iphone-repair-or-replace": articleRepairV2,
  "rakuten-guide": articleRakutenV2,
  "used-iphone-checklist": articleUsedIphoneV2,
};

export const articles = [
  {
    id: "rakuten-iphone-17e",
    category: "楽天モバイル・端末購入",
    readTime: "9分",
    excerpt: "iPhone 17e 256GBを楽天モバイルで買うと毎月いくら？ MNP月1円の条件、2年返却と買い切り、機種変更の価格を整理します。",
    title: "楽天モバイルでiPhone 17eを買うと毎月いくら？ 2年返却と買い切りを比較",
    date: "2026.09.25",
    image: articleRakutenV2,
  },
  {
    id: "rakuten-iphone-18-pro",
    category: "楽天モバイル・端末購入",
    readTime: "10分",
    excerpt: "楽天モバイルでiPhone 18 Proを買うと毎月いくら？ 256GBの48回払い・2年返却・買い切り、通信料とポイント条件を整理します。",
    title: "楽天モバイルでiPhone 18 Proを買うと毎月いくら？ 2年返却と買い切りを比較",
    date: "2026.09.25",
    image: articleRakutenV2,
  },
  {
    id: "sim-only-mnp-campaigns",
    category: "乗り換え特典",
    readTime: "6分",
    excerpt: "iPhoneをそのまま使う人向け。ahamo・UQ mobile・LINEMO・Y!mobile・楽天モバイルのSIMのみMNP特典と受取条件を比較します。",
    title: "SIMのみMNP特典はどこがいい？ 5社の条件と受け取り方",
    date: "2026.09.23",
    image: articleBeforeSwitchingV2,
  },
  {
    id: "iphone-18-pro-mnp",
    category: "端末購入",
    readTime: "7分",
    excerpt: "約2年で返却するか、返却せず使い続けるか。iPhone 18 Pro 256GBのMNP購入を、端末代と返却時の利用料を分けて比較します。",
    title: "iPhone 18 Proはどこで買う？ 2年で返却する人・使い続ける人の選び方",
    date: "2026.09.23",
    image: articleIphoneBuyV2,
  },
  {
    id: "uqmobile-guide",
    category: "通信会社",
    readTime: "10分",
    excerpt: "au回線、店舗、30〜35GB、10分通話、端末購入、2万円相当還元まで、UQ mobileが向く人を具体的に解説します。",
    title: "安くしたい。でもオンラインだけでは不安——UQ mobileならau回線・店舗・端末購入がそろう",
    date: "2026.09.20",
    image: articleIphoneBuyV2,
  },
  {
    id: "ymobile-guide",
    category: "通信会社",
    readTime: "10分",
    excerpt: "店舗の安心感、家族割、30〜35GB、端末購入、豊富なキャンペーンまで、ワイモバイルが向く人を具体的に整理します。",
    title: "スマホ代は下げたい。でも格安SIMは不安——そんな人にワイモバイルがちょうどいい理由",
    date: "2026.09.20",
    image: articleIphoneBuyV2,
  },
  {
    id: "are-you-overpaying",
    category: "料金の見直し",
    readTime: "10分",
    excerpt: "40年前と現在の料金を比べながら、見直していない人が払い続けやすい5つと、今日できる3つを整理します。",
    title: "スマホ代、損してない？ 40年で約8割下がったのに払い続けているもの",
    date: "2026.09.20",
    image: articleBillBasicsV2,
  },
  {
    id: "which-plan-is-cheapest",
    category: "料金比較",
    readTime: "12分",
    excerpt: "使用量ごとに料金の候補を整理。容量・通話条件の違いと、サポートや割引も確認します。",
    title: "結局どこが安い？ スマホ料金の候補を使用量別に整理",
    date: "2026.09.20",
    image: articleBillBasicsV2,
  },
  {
    id: "return-program",
    category: "端末購入",
    readTime: "5分",
    excerpt: "通信会社で購入したiPhoneを約2年後に返す場合の、4社の返却時期・利用料・故障時の追加費用を整理します。",
    title: "購入したiPhoneを2年で返すなら？ 4社の返却時期と費用",
    date: "2026.09.23",
    image: articleReturnProgram,
  },
  {
    id: "iijmio-iphone-no-return",
    category: "端末購入",
    readTime: "9分",
    excerpt: "2026年9月のiPhone 14良品の価格を例に、2年返却なし・通信料込み月2,000円台の買い替えを紹介。現在の価格・在庫は公式で確認してください。",
    title: "10万円の新品も、2年返却も選ばなかった。母のiPhoneを月2,609円で買い替える方法",
    date: "2026.09.20",
    image: articleIijmioV2,
  },
  ...legacyArticles.map(({ bodyHtml: _bodyHtml, toc: _toc, ...article }) => ({
    ...article,
    image: legacyArticleImages[article.id] || articleBillBasicsV2,
  })),
];
